<template>
  <div class="home" id="home">
    <div class="header" id="header">
      <!-- <img src="@/assets/member-bg.png" alt="rv-image" class="header-image" /> -->
      <v-container>
        <div id="Heading" class="text-light display-2 text-center">Introducing Route Line</div>
        <div class="text-light text-subtitle2 text-center" id="HeaderSubText">
          A-first-of-a-kind membership providing access to premium RVs and adventure vehicles.
          Opt out of high maintenance ownership and explore the outdoors hassle free!
        </div>
        <div class="text-light text-h6 text-center" id="Offer-Text">
          MAKE YOUR SUMMER PLANS! IMMEDIATE ACCESS! Limited Time Only Summer Special 1/2 off initiation! fees
        </div>
      </v-container>
    </div>
    <!-- end about us -->

    <!-- service  -->
    <section>
      <v-container>
        <div class="cards" id="card">
          <div v-for="(n, i) in plans" :key="i" :id="n.id">
            <Membership
              :nth="(i + 1) % 2 === 0 ? true : false"
              :data="n"
              :show="true"
            />
          </div>
        </div>
      </v-container>
    </section>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <img src="@/assets/mem/taxa.png" alt="" class="images" id="img1" />
          </div>
          <div class="col-sm-12 col-md-4">
            <img src="@/assets/mem/scout.png" alt="" class="images" id="img2" />
          </div>
          <div class="col-sm-12 col-md-4">
            <img src="@/assets/mem/sprinter.png" alt="" class="images" id="img3" />
          </div>
        </div>
      </div>
    </section>

    <!-- about founder  -->
    <!-- <section class="service-form mt-5 pt-5 mb-5">
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="4" class="pb-5 mb-3 mx-auto">
            <v-row class="mt-5 pt-5 text-white pl-2 pr-2">
              <div class="text-white" v-text="'Need More Help?'"></div>
              <div
                class="text-h5 text-primary font-weight-bold text-white"
                v-text="'WANT TO LEARN ABOUT MEMBER BENEFITS?'"
              ></div>
              <div
                class="text-subtitle-1 mt-2 text-white"
                v-text="
                  'Fill out this form and we will reach out to help get you closer to the most exciting step you could take all year.'
                "
              ></div>
            </v-row>
          </v-col>
          <v-spacer md="1"></v-spacer>
          <v-col cols="12" sm="12" md="7">
            <v-card class="pa-5">
              <v-card-text> Query Form </v-card-text>
              <form @submit.prevent="submit">
                <v-row class="ma-0 pa-0">
                  <v-col md="6" class="ma-0" cols="12">
                    <v-text-field label="Name" v-model="name" outlined required>
                    </v-text-field>
                  </v-col>
                  <v-col md="6" class="ma-0" cols="12">
                    <v-text-field
                      label="E-mail"
                      v-model="email"
                      required
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col md="6" class="ma-0" cols="12">
                    <v-text-field
                      label="Phone"
                      v-model="phone"
                      outlined
                      required
                    >
                    </v-text-field>
                  </v-col>
                  <v-col md="6" class="ma-0" cols="12">
                    <v-text-field label="City" v-model="city" outlined required>
                    </v-text-field>
                  </v-col>
                  <v-col md="12" cols="12">
                    <v-textarea
                      outlined
                      label="Message"
                      v-model="message"
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <v-col md="12" cols="12">
                    <v-btn
                      block
                      color="primary"
                      class="mx-auto"
                      dark
                      large
                      type="submit"
                    >
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section> -->
    <!-- <v-spacer class="py-5"></v-spacer>
    <v-spacer class="py-5"></v-spacer> -->
    <!-- end about founder -->

    <!-- get in touch -->
    <!-- <Getintouch /> -->
    <!-- end get in touch -->
  </div>
</template>

<script>
// import Getintouch from "@/components/cards/Getintouch.vue";
import Membership from "../components/cards/Membership.vue";
import { dbFs } from "../modules/database";
import axios from "../modules/axios";
// import _ from "loadsh";
import { mapGetters } from "vuex";
import router from "@/router/index";

export default {
  components: { Membership },
  data: () => {
    return {
      users: [],
      name: "",
      email: "",
      phone: "",
      city: "",
      message: "",
      plans: [],
      // plans: [
      //   {
      //     name: "Any Day Subscription",
      //     title: "(No Commitment 45-day trial period)",
      //     price: "$350",
      //     description:
      //       "For the cost of one-night rental, you can have 7-day-a-week access to our fleet. Experience the perks of our top tier membership (if you don’t love it, cancel within 45 days without penalty. But–you won’t wanna!)",
      //     to: "/customer/create?plan=anyday",
      //     permonth: true,
      //   },

      //   {
      //     name: "Weekday Subscription",
      //     title: "(No Commitment 45-day trial period)",
      //     price: "$100",
      //     description:
      //       "Remote life! Why spend your work week at home when you can be in the wild! For less than one night rental, join our weekday membership program and take your show on the road!",
      //     to: "/customer/create?plan=weekday100",
      //     permonth: true,
      //   },
      // ],
    };
  },
  mounted() {
    this.getPlans();
    if ( this.user?.plan ) {
      router.push("/");
      return;
    }
  },
  methods: {
    submit() {
      const data = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        city: this.city,
        message: this.message,
        type: "membership",
      };

      dbFs
        .collection("contact")
        .add(data)
        .then(() => {
          this.name = "";
          this.email = "";
          this.phone = "";
          this.city = "";
          this.message = "";
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$root.toast(
            "Your message has been sent successfully.",
            "success"
          );
        });
    },
    getPlans() {
      axios.get(`/plan`).then((res) => {
        // this.plans = res.data;
        let newplan = [];
        res.data.forEach((plan) => {
          const desc = plan.description?.split("~");
          newplan.push({
            name: plan.title,
            title: plan.name,
            price: desc?.[0] || '',
            description: plan.subtitle,
            to: `/customer/create?plan=${plan.id}`,
            group_id: plan.group_id,
            subtitle: desc?.[desc?.length - 1],
            priceTag: desc?.length > 2 ? desc?.[1] || '' : desc?.[0],
          });
        });

        // const grouped = _.groupBy(newplan, (plan) => plan.group_id);
        // const keys = Object.keys(grouped);

        // const tempPlan = [];

        // keys.forEach((key) => {
        //   const arr = grouped[key];
        //   let obj = {};

        //   arr.forEach((ar, index) => {
        //     if ( index === 1 ) {
        //       obj = {
        //         ...obj,
        //         description1: ar.description,
        //         name1: ar.name,
        //         price1: ar.price,
        //         title1: ar.title,
        //         to1: ar.to,
        //         subtitle1: ar.subtitle,
        //         price1Tag: ar.priceTag
        //       }
        //     } else {

        //       obj = {
        //         ...obj,
        //         ...ar,
        //       }
        //     }
        //   });

          // tempPlan.push(obj);
        // });

        this.plans = newplan;
      });
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
   watch: {
    user() {
      if ( this.user?.plan ) {
        router.push("/");
        return;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.home {
  margin-bottom: 20px;
}
.divider-border {
  border: 3px solid #a7e0e4;
}
.text-white {
  color: white;
}
.membership-background {
  background: var(--primary-color);
  color: white;
}
.membership-header {
  &-top {
    height: 70px;
    background: var(--primary-color);
    border-radius: 9px 9px 0px 0px;
    opacity: 1;
    color: white;
    text-transform: uppercase;
    font-weight: bold;
  }
  &-top2 {
    height: 70px;
    background: white;
    border-radius: 9px 9px 0px 0px;
    opacity: 1;
    color: var(--primary-color);
    text-transform: uppercase;
    font-weight: bold;
  }
  &-subtitle {
    font-size: 1.2rem;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 0;
    text-align: center;
  }
}
.flip-image {
  transform: scaleX(-1);
}
.header {
  position: relative;

  &-image {
    width: 100%;
    height: 43vh;
    object-fit: cover;
    position: relative;
  }
  &-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
  &-text {
    font-size: 72px;
    font-weight: bold;
    color: var(--light);
    margin-left: 10%;
    margin-bottom: 30px;
  }
  &-overlap {
    width: 100%;
    height: 100px;
    background-color: var(--primary-color);
  }
  &-search {
    margin-bottom: -20px;
    position: relative;
    z-index: 2;
  }
}
.service {
  position: relative;

  &-image {
    width: 100%;
    height: 43vh;
    margin: auto;
  }
  &-image-2 {
    width: 80%;
    margin: auto;
  }
  &-image2 {
    width: 70%;
    height: 43vh;
    margin: auto;
  }
  &-ringleft {
    position: absolute;
    left: -60px;
    top: -60px;
  }
  &-ringright {
    position: absolute;
    right: -100px;
    bottom: -60px;
  }
  &-ring-img {
    width: 200px;
  }
  &-card-icon {
    background: transparent
      linear-gradient(189deg, #166b82 0%, #59a1af 36%, #a7e0e4 100%) 0% 0%
      no-repeat padding-box;
    width: 39px;
    height: 41px;
    border-radius: 11px;
    top: 50%;
    margin: auto;
  }
  &-card-content {
    color: var(--parimary-color);
    font-size: 16px;
    text-align: left;
  }
  &-form {
    background: linear-gradient(180deg, #166b82 0%, #59a1af 36%, #a7e0e4 100%)
      0% 0% no-repeat padding-box;
  }
}
.custome-text {
  color: var(--white);
  text-align: center;
  font: normal 14px Poppins;
  background: var(--primary-color) 0% 0% no-repeat padding-box;
  color: #ffffff;
  opacity: 1;
  border-radius: 0px 0px 18px 18px;
  &-2 {
    font: bold 16px Poppins;
    background: var(--primary-color) 0% 0% no-repeat padding-box;
    color: #ffffff;
    opacity: 1;
    // border-radius: 0px 0px 18px 18px;
  }
}
</style>
<style lang="scss" scoped>
.cards {
  display: flex;
  justify-content: center;
  column-gap: 50px;
  flex-wrap: wrap;
}
.main {
  background: #b3b3b3;
}
#content {
  position: relative;
}
.bg-map {
  position: absolute;
  left: 0;
  right: 0;
  top: -3rem;
  bottom: -3rem;
  z-index: 0;
}
.high-zindex {
  position: relative;
  z-index: 1;
}
.how-works {
  width: 100%;
  pointer-events: none;
}
.header {
  background: var(--primary-color);
  padding-bottom: 50px;
  padding-top: 30px;

  &-img {
    height: 100%;
  }
  &-image {
    width: 100%;
  }
  &-content {
    color: #fff;
    text-align: center;
  }
  &-subtitle {
    font-size: 18px;
  }
}
.images {
  width: 100%;
}
</style>
<style>
.artibot-wrapper--19YJW {
  display: show;
}
</style>
